import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSuppliers } from '../../../features/suppliers/services/supplierService';

// Async thunk to fetch suppliers
export const fetchSuppliers = createAsyncThunk(
  'suppliers/fetchSuppliers',
  async (config = {}, { rejectWithValue }) => {
    try {
      const response = await getSuppliers(config);
      const supplierData = response?.payload || response || [];
      return Array.isArray(supplierData) ? supplierData : [];
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch suppliers');
    }
  }
);

const supplierSlice = createSlice({
  name: 'suppliers',
  initialState: {
    suppliers: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    addSupplierToStore: (state, action) => {
      state.suppliers.push(action.payload);
    },
    updateSupplierInStore: (state, action) => {
      const index = state.suppliers.findIndex(s => s.Id === action.payload.Id);
      if (index !== -1) {
        state.suppliers[index] = action.payload;
      }
    },
    removeSupplierFromStore: (state, action) => {
      state.suppliers = state.suppliers.filter(s => s.Id !== action.payload);
    },
    resetSuppliers: (state) => {
      state.suppliers = [];
      state.error = null;
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuppliers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.suppliers = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchSuppliers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { 
  addSupplierToStore, 
  updateSupplierInStore, 
  removeSupplierFromStore, 
  resetSuppliers 
} = supplierSlice.actions;

export default supplierSlice.reducer;
